import { TransitionAsset } from 'models/Asset'

export const addAttachedTransition = (transitions, allAssets, others) => transitions.concat(
  TransitionAsset.filter(allAssets).filter(
    transition => others.some(asset => transition.isAttachedTo(asset.id))
  )
)
